import { getActivePinia, storeToRefs, } from 'pinia'
import { ERROR, usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { useComponentIsActive, } from '@/assets/js/src/util/composables/useComponentIsActive'
import { useReadingPlanListStore, } from '@/assets/js/src/modules/readingPlan/_pinia/readingPlanList'
import { computed, ref, watch, onActivated, onUnmounted, } from 'vue'
import { mapUserOptionByPath, } from '@/assets/js/src/modules/user/_pinia/mapUserOptionByPath'
import { debounce, } from '@/assets/js/src/util/uiTools'
import { useUserOptions, } from '@/assets/js/src/modules/user/_composables/useUserOptions'

export function useReadingPlanListApi () {
    let activePinia = getActivePinia()
    let readingPlanListStore = useReadingPlanListStore(activePinia)

    const { readingPlansFetched, readingPlansMeta, readingPlans, reload, } = storeToRefs(readingPlanListStore)
    const { messagesLoaded, asyncStatus, allAsyncLoaded, updateData, } = usePrefetchData({
        actions: [
            {
                item: readingPlansFetched,
                action: readingPlanListStore.getReadingPlans,
            },
            {
                item: readingPlansMeta,
                action: readingPlanListStore.getReadingPlansMeta,
            },
        ],
        loadAsyncMessages: [ 'reading_plan', 'common', ],
    })

    let { componentIsActive, } = useComponentIsActive()

    watch(reload, async (newBoolean, oldBoolean) => {
        if (newBoolean && newBoolean !== oldBoolean && componentIsActive) {
            await updateData()
            readingPlanListStore.reload = false
        }
    })

    const debouncedMy = computed(mapUserOptionByPath('readingPlan/list/my'))
    watch(debouncedMy, () => readingPlanListStore.reload = true)

    let { getUserOption, } = useUserOptions()
    let my = ref(getUserOption('readingPlan/list/my'))
    watch(my,
        debounce((newVal) => debouncedMy.value = newVal, 300),
        { immediate: !import.meta.env.SSR, })

    onActivated(async () => {
        if (reload.value) {
            await updateData()
            readingPlanListStore.reload = false
        }
    })
    
    onUnmounted(()=>{
        readingPlanListStore.$reset()
    })

    const asyncStatusError = computed(()=>asyncStatus.value === ERROR)

    return {
        readingPlans,
        readingPlansMeta,
        my,
        messagesLoaded,
        allAsyncLoaded,
        asyncStatusError,
    }
}
